import http from './http.service';

class HelpService {
    constructor() {
        this.baseUrl = "/api/help";
    }

    getMenuItems(includeDeactivated) {
        return http.get(`${this.baseUrl}/getMenuItems`, { params: { includeDeactivated } });
    }

    getMenuItemData(id) {
        return http.get(`${this.baseUrl}/getMenuItemData`, { params: { id } });
    }

    saveMenuItemData(model) {
        return http.post(`${this.baseUrl}/saveMenuItemData`, model);
    }

    saveUserHelpContent(model) {
        return http.post(`${this.baseUrl}/saveUserHelpContent`, model);
    }
}

export default new HelpService();
